import React from "react";

const Authmiddleware = (props) => {
  // Retrieve userId and usersessionId from cookies
 
  
  return (
    <React.Fragment>
      {props.children}
    </React.Fragment>
  );
};

export default Authmiddleware;
